import { Mapper } from "../../../../base/utils/mapper";
import { KappaModel } from "../../../../domain/models/consult/kappa.model";
import { KappaEntity } from "../entities/kappa.entity";

export class KappaImplementationRepositoryMapper extends Mapper<KappaEntity, KappaModel> {
    mapFrom(param: KappaEntity): KappaModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: KappaModel): KappaEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}